import i18n from "@breward/i18n";

export const DISCOUNT_CODE_STATES: {
  [key: string]: { label: string; color: string };
} = {
  active: {
    label: i18n.t("global:shared.DiscountCodeStates.Active", "Active"),
    color: "success",
  },
  used: {
    label: i18n.t("global:shared.DiscountCodeStates.Used", "Used"),
    color: "error",
  },
  inactive: {
    label: i18n.t("global:shared.DiscountCodeStates.Inactive", "Inactive"),
    color: "disabled",
  },
};

export const DISCOUNT_TYPES: {
  [key: string]: string;
} = {
  percentage: i18n.t("global:shared.DiscountType.Percentage", "Percentage"),
  amount: i18n.t("global:shared.DiscountType.Amount", "Amount"),
};

export const DISCOUNT_CODE_TYPES: {
  [key: string]: string;
} = {
  single: i18n.t("global:shared.DiscountCodeType.Single", "Single"),
  multi: i18n.t("global:shared.DiscountCodeType.Multi", "Multi"),
};

export const AVAILABLE_VALIDATORS = [
  {
    label: "Członkostwo w PSPD",
    value: JSON.stringify({
      label: "Członkostwo w PSPD",
      module_name: "PspdMembershipValidator",
      function_name: "validate",
    }),
  },
];
